import { handleError, handleResponse, MyAxios } from '@services/SettingAxios';
import { TypePromiseInfoMessageShops } from './TypePromise';

class ServiceInfoMessage {
  async getInfoMessageShops(code: string): Promise<TypePromiseInfoMessageShops> {
    return MyAxios.get(`/api/shops/topbar-region?code=${code}`)
      .then(handleResponse)
      .catch(error => handleError(error, null));
  }

  async getInfoMessageByShop(shopId: number): Promise<TypePromiseInfoMessageShops> {
    return MyAxios.get(`/api/shops/topbar-shop?id=${shopId}`)
      .then(handleResponse)
      .catch(error => handleError(error, []));
  }
}

const serviceInfoMessageInstance = new ServiceInfoMessage();

export default serviceInfoMessageInstance;
